<template>
  <div class="container">
    <div class="page-title">下载</div>
    <div class="content">
      <div class="date-box" style="padding-left: 8px;display: flex;justify-content: center;margin: 20px 0;">
        <el-input
          style="width: 300px;margin-right: 20px;"
          placeholder="请输入文件名"
          v-model="name"
          clearable>
        </el-input>
        <el-button type="primary" size="middle" icon="el-icon-search" @click="search()">查询</el-button>
      </div>
      <div class="content-bottom">
        <el-table
          :data="tableData"
          stripe
          style="width: 100%"
          v-loading="listLoading"
          :row-class-name="tableRowClassName"
        >
          >
          <el-table-column
            prop="wineName"
            label="文件名"
            width="300">
            <template slot-scope="scope">
              <div class="file-info">
                <img class="file-image" src="../../../assets/imgs/load.png" alt="">
                <div class="info-box">
                  <div class="info-title"> {{scope.row.name}} </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--            prop="wineName"-->
          <!--            label="回访周期"-->
          <!--            width="140">-->
          <!--            <template slot-scope="scope">-->
          <!--              <div style="display: flex;align-items: center;">-->
          <!--                <img style="width: 100%;height: 100%;object-fit: contain;" :src="baseURL + '/images'+item.imgSmallUrl">-->
          <!--                {{scope.row.id}}-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="fileType"
            label="文件类型"
            width="80">
          </el-table-column>
          <el-table-column
            prop="fileSize"
            label="文件大小"
            width="80">
          </el-table-column>
          <el-table-column
            prop="wineName"
            label="下载"
            width="200">s
            <template slot-scope="scope">
              <i class="el-icon-download load-icon" @click="getFileDownload(scope.row.id, scope.row.name )"></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-size="pageSize"
      :page-sizes="[5, 10, 20, 40]"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    ></el-pagination>
    <el-dialog
      title="下载提示"
      :visible.sync="dialogVisible"
      width="30%">
      <el-link style="margin-right: 20px;" type="primary" v-if="downUrl" @click="download(downUrl)">下载链接1</el-link>
      <el-link type="primary" v-if="downUrl1" @click="download(downUrl1)">下载链接2</el-link>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
  </span>
    </el-dialog>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        name: '',
        tableData: [],
        listLoading: false,
        total: 0,
        pageSize: 10,
        currentPage:1,
        dialogVisible: false,
        downUrl: '',
        downUrl1: '',
        id: ''
      };
    },
    created () {
    },
    activated () {
      this.id = this.$route.query.id;
      const listData = this.$route.query.listData || {};
      if(listData.list && listData.list.length > 0){
        this.listLoading = false;
        this.tableData = listData.list;
        this.total = listData.total;
      }else{
        this.queryData(this.currentPage,this.pageSize);
      }

    },
    methods: {
      queryData(currentPage,pageSize){
        this.listLoading = true;
        this.$http.post(`/user/getFileListByPath/${currentPage}/${pageSize}`, {
          parentId: this.id,
          name: this.name
        }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            this.listLoading = false;
            console.log('res====',res)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              this.tableData = res.data.data.list;
              this.total = res.data.data.total;
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      handleSizeChange: function (size) {
        this.pageSize = size;
        console.log(this.pageSize);  //每页下拉显示数据
        this.queryData(this.currentPage,this.pageSize);
      },
      handleCurrentChange: function(currentPage){
        this.currentPage = currentPage;
        console.log(this.currentPage);  //点击第几页
        this.queryData(this.currentPage,this.pageSize);
      },
      getFileDownload(fileId, fileName){
        this.listLoading = true;
        this.$http.post(`/user/getFileDownload?fileId=${fileId}&fileName=${fileName}`, {
          fileId, fileName
        }, { headers: {
            token: window.sessionStorage.manageToken
          }})
          .then(res => {
            this.listLoading = false;
            console.log('res====',res)
            if (res.data.code === 'ok') {
              console.log('resdatadata====',res.data.data)
              const data = res.data.data;
              // this.dialogVisible = true;
              // this.downUrl = data.downUrl;
              // this.downUrl1 = data.downUrl1;
              this.download(data.downUrl);
            } else {
              this.$message.error(res.data.data)
            }
          });
      },
      download(downUrl){
        window.open(downUrl);
      },
      tableRowClassName({row, rowIndex}) {
        console.log('row',row)
        if (row.nextBuy === 1) {
          return 'red-row';
        }
        return '';
      },
      search(){
        this.currentPage = 1;
        this.queryData(this.currentPage,this.pageSize);
      },
    },
    filters: {
      rTime(data) {
        if(!data) return
        var dt = new Date(data);
        var y = dt.getFullYear();
        var m = (dt.getMonth()+1).toString().padStart(2,"0");
        var d = dt.getDate().toString().padStart(2,"0");
        var h = dt.getHours().toString().padStart(2,"0");
        var mm = dt.getMinutes().toString().padStart(2,"0");
        var s = dt.getSeconds().toString().padStart(2,"0");
        return `${y}-${m}-${d} ${h}:${mm}:${s}`;
      },
      bytesToSize(bytes) {
        if (bytes === 0) return '0 B';
        var k = 1000; // or 1024
         const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
         const i = Math.floor(Math.log(bytes) / Math.log(k));
        return (bytes / Math.pow(k, i)).toPrecision(3) + ' ' + sizes[i];
  }
    }
  };
</script>
<style lang="less" scoped>
  /deep/ .red-row {
    color: red;
  }
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
  }
  .content {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow: auto;
    .content-top {
      display: flex;
      margin-top: 10px;
      /*justify-content: flex-start;*/
      flex-direction: column;
    }
    .first-line {
      display: flex;
      justify-content: flex-start;
      margin-bottom: 20px;
    }
    .label {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /*text-align: right;*/
      font-size: 16px;
      color: #000000;
      padding-right: 10px;
    }
    .date-box {
      display: flex;
      align-items: center;
      padding-left: 12px;
    }
    .third-line {
      margin-left: 20px;
      margin-top: 10px;
    }
  }
  .content-bottom {
    overflow: auto;
    margin-bottom: 10px;
    flex: 1;
    padding-left: 12px;
  }
  .file-info {
    display: flex;
    align-items: center;
    .file-image {
      width: 40px;
      object-fit: contain;
      margin-right: 20px;
    }
    .info-box {
      .info-title {
        font-weight: 600;
      }
    }
  }
  .load-icon {
    padding: 10px;
    cursor: pointer;
  }
</style>
